<template>
  <div >
 

      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">{{nome_pai}}</h4>
          </div>
        </md-card-header>
        <md-card-content style="max-height: 700px; overflow-y: scroll">

   <div class="md-layout" v-if="loading">
                 
                  <div class="md-layout-item md-size-100">
                        <md-progress-spinner  :md-diameter="30" md-mode="indeterminate"></md-progress-spinner> {{msg_status}} ..
                  </div>
         </div>




              <div class="md-layout">
                 <div class="md-layout-item md-size-100" >

                        

                          <table class="striped edit-table" v-for="(item, index) in items" :key="index"  >
                              <thead>
                                <tr>
                                  <th v-bind:colspan="colSpan">
                                              {{item.nome}}
                                  </th>
                                  
                                </tr>
                              </thead>
                              <tbody>
                                  <tr v-for="(item2, index2) in item.itens" :key="index2">
                                        <td>{{index2+1}} </td>
                                        <td>{{item2.nome}}</td>
                                        <td>
                                                <select v-bind:id="getIDItem('nota', item2)" v-model="item2.nota" class="campo_user" title="Selecione a nota para este item">
                                                  <option :value=10>C</option>
                                                  <option :value=0>N/C</option>
                                                  <option :value=-1>N/A</option>	
                                                  </select>
                                          
                                      
                                        </td>
                                        <td v-if="id_pai != null && id_pai != undefined && parseInt(id_pai) > 0 " style="max-width:  35px">
                                          
                                                       <md-button title="Parecer / Vídeo"
                                                            v-on:click="seleciona_item2(item2, index2)"
                                                                    v-bind:class="getCorItem(item2,'parecer')">
                                                                    <md-icon>description</md-icon>
                                                                    <!-- 
                                                                    @click="abrir_modal_itens(item, index)" -->
                                                        </md-button>
                                        </td>
                                          <td v-if="id_pai != null && id_pai != undefined && parseInt(id_pai) > 0 " style="max-width:  35px">
                                          
                                                       <md-button title="Mídia / Observações / Vídeo"
                                                            v-on:click="seleciona_item(item2, index2)"
                                                                    v-bind:class="getCorItem(item2,'midia')">
                                                                    <md-icon>image</md-icon>
                                                                    <!-- 
                                                                    @click="abrir_modal_itens(item, index)" -->
                                                        </md-button>
                                        </td>
                              
                                    
                                  </tr>
                              </tbody>
                              <tfoot >
                                <tr v-if="item.itens.length <= 0">
                                  <td v-bind:colspan="colSpan">
                                    <i>Sem registros</i></td>
                                </tr>
                                <tr v-if="false">
                                  <td colspan="10">
                                  
                                      <md-button class="md-info pull-right"
                                              type="button" v-bind:disabled="disableButton"
                                              v-on:click="salvar">Salvar</md-button>
                                  </td>
                                </tr>
                              </tfoot>

                          </table>
                   </div>
                </div>


        </md-card-content>
      </md-card>



   <modal v-if="show_modal" @close="closeModal()" class="md-size-75">
        <div slot="header">Mídia / Arquivos</div>
              <div slot="body">
                  <tab_midia :item="item_selecinonado" field_qtde="qtde_arquivos" :enable_edit="enable_edit"></tab_midia>
              </div>

    </modal> 

    
   <modal v-if="show_modal2" @close="closeModal2()" class="md-size-70">   

              <div slot="body">
                  <tab_textos v-model="item_selecinonado" :enable_edit="enable_edit"></tab_textos>
              </div>

    </modal> 



  </div>



</template>

<script>

import service from "../../../services/InspecaoItemService";
import serviceCheckList from "../../../services/ModeloChecklistService";
import modal from '../../../components/Modal';
import tab_midia from './tab_midia';
import tab_textos from './tab_textos';

    export default {
            components: { modal, tab_midia , tab_textos },   
  
        props: ['tabela', 'id_modelo_checklist', 'id_pai', 'id_inspecao', 'onSave',
                         'onPreSave', 'change_itens','ls_items', 'tab_midia', 'p_enable_edit'],
         model: {
            prop: 'ls_items',
            event: 'blur'
        },
        data: function() {
            return {
                
              items: [],
              colSpan: 3,

              ids_excluir: [],

              action: "list",
              id: "",
              table: null,
              filtro_titulo: "",
              filtro_status: "",

              show_new_button: true,

              

              loading: false, 
              msg_status: "Carregando",
              disableButton: false,

              nome_pai: "",
			  
			  
              
              message_text:"",
              show_message:"off",

              show_modal: false,
              show_modal2: false,
              item_selecinonado: null,
              index_item: -1,
              enable_edit: true,


              button_new_text: "" //<i class=\"fa fa-file\" ></i> NOVA POST"
            }
        },
        methods: {

                getCorItem(item,tipo){
                   var padrao = "md-just-icon md-primary";

                   if ( tipo == "parecer"){
                           if ( item.video != null && item.video.toString().length > 1 ){
                                 padrao = "md-just-icon md-danger";  
                           }
                           if ( item.parecer != null && item.parecer.toString().length > 1 ){
                                 padrao = "md-just-icon md-danger";  
                           }
                   }
                   
                   if ( tipo == "midia"){
                          if ( item.qtde_arquivos != null && item.qtde_arquivos > 0 ){
                                  
                                 padrao = "md-just-icon md-danger";  
                          }
                   }

                   return padrao;
                },

             closeModal(){

                this.show_modal = false;
                if ( this.item_selecinonado != undefined ){
                    this.items[this.index_item] = this.item_selecinonado;

                }

            },
            closeModal2(){
                    this.show_modal2 = false;
                if ( this.item_selecinonado != undefined ){
                    this.items[this.index_item] = this.item_selecinonado;

                }  
            },
            
            getIDItem(nome, item){
                return "item_"+item.id_item.toString()+"_L" + nome;
            },
            change_data_item(id_campo, value){

            },
            change_value(event){

              this.change_data_item( event.target.id, event.target.value );

        
            },
            excluir(item, index){

              console.log("Excluir? ");

                if (item.id != null &&  item.id != ""){

                     this.ids_excluir.unshift(  item.id );
                }

                this.items.splice(index, 1);
            },
            datepicker_return(dateText, inst){
                         console.log("Cheguei aqui? ");
            },
            salvar(){
                      var self = this;
                      var hd_json = JSON.stringify(this.items);
                      var ids_delete_json =  JSON.stringify(this.ids_excluir);

                      if ( this.onPreSave != null  && this.onPreSave != undefined ){
                            this.onPreSave(  this.tabela,  this.id_pai );
                      }

                      
                      self.disableButton = true;
                      self.loading = true;
                      self.msg_status = "Salvando";

                      service.salvarGrid(hd_json, ids_delete_json, this.tabela, this.id_pai ).then( 
                            function (response)
                            {

                              
                                 self.disableButton = false;
                                 self.loading = false;
                                 self.msg_status = "Carregando";      
                                 self.show_message = "on";
                                 self.message_text = "Contatos salvos com sucesso!";
								 
                                             if (self.onSave != null && self.onSave != undefined ){
                                                   
                                                    self.onSave(  self.tabela,  self.id_pai , self.items );
                                             }                     
                            }
                       ).catch(function(error){
                          console.log( JSON.parse(  JSON.stringify(error ) ));
                      });
            },
            add(){
                  this.items.push( this.getArrayItem() );
            },
            seleciona_item2(item, index){
              this.item_selecinonado = item;
              this.show_modal2 = true;

            },
            seleciona_item(item, index){
              this.item_selecinonado = item;
              this.show_modal = true;
            },
            loadData(){
              var self  = this;

                var url =  "contatos_gridcad"; // 
                this.disableButton = true;
                this.loading = true;
                this.msg_status = "Carregando";

                var data = { id_modelo_checklist: this.id_modelo_checklist}

                  if ( this.id_pai != null && this.id_pai != undefined ){
                                 data["id_inspecao"] = this.id_pai;
                  }

                service.getList( data ).then(function (response){


                                 self.items = response.data;
                                 self.disableButton = false;
                                 self.loading = false;
                                 self.msg_status = "Carregando";

                                  if ( self.change_itens != null && self.change_itens != undefined ){
                                           self.change_itens( self.items );

                                  }
                                  
                                self.$emit('blur', self.items );
                                 //self.$emit("update:inspecao_items", self.items);

                                
                                 
                }).catch(function(error){
                    console.log( JSON.parse(  JSON.stringify(error)));
                });


                serviceCheckList.getById(this.id_modelo_checklist).then(function (response){

                  var form = response.data.data;
                  self.nome_pai = form.nome;

                });
                
            },
            getArrayItem(){
                      var data = service.getModel(); 

                        if ( this.tabela != null ){
                               data["tabela"] = this.tabela;
                         } 
                        if ( this.id_pai != null ){
                               data["id_pai"] = this.id_pai;

                        } 


                      return data;
            }
            
        },
        mounted() {

                let self = this;

                console.log("recarrega? " + this.id_pai );

                 if ( this.id_pai != null && this.id_pai != undefined && parseInt(this.id_pai) > 0 ){
                   this.colSpan = 5;
                 }

                 if ( this.id_modelo_checklist == null || this.id_modelo_checklist == undefined ){
                     return;
                 }

                 if ( this.p_enable_edit != null && this.p_enable_edit != undefined ){
                   this.enable_edit = this.p_enable_edit;
                 }

               

                this.loadData();
             
  
        }
    }
    </script>